import { getToken } from './tokenStorage';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api/v1';


async function request(endpoint, options = {}) {
  const token = getToken();
  
  const headers = {
    'Content-Type': 'application/json',
    ...options.headers,
  };

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const config = {
    credentials: 'include',
    ...options,
    headers,
  };

  if (config.body && typeof config.body === 'object') {
    config.body = JSON.stringify(config.body);
  }

  try {
    const response = await fetch(`${API_URL}${endpoint}`, config);
    const data = await response.json();

    if (!response.ok) {
      console.log("API Error Data:", data); // DEBUG
      const error = new Error(data.message || 'Xatolik yuz berdi');
      error.errorCode = data.errorCode || 'REQUEST_FAILED';
      error.status = response.status;
      throw error;
    }

    // Backend GlobalInterceptor sababli ma'lumotlar .data ichida keladi
    // Agar success: true bo'lsa, ma'lumotni o'zini qaytaramiz
    if (data && data.success === true && data.data !== undefined) {
      return data.data;
    }

    return data;
  } catch (error) {
    if (error.status >= 500) {
      console.error("Critical API Error:", error);
    }
    throw error;
  }
}

export const apiService = {
  get: (endpoint, options) => request(endpoint, { ...options, method: 'GET' }),
  post: (endpoint, body, options) => request(endpoint, { ...options, method: 'POST', body }),
  put: (endpoint, body, options) => request(endpoint, { ...options, method: 'PUT', body }),
  patch: (endpoint, body, options) => request(endpoint, { ...options, method: 'PATCH', body }),
  delete: (endpoint, options) => request(endpoint, { ...options, method: 'DELETE' }),

  // Orders
  createOrder: (data) => request('/orders', { method: 'POST', body: data }),
  getQueuePosition: (orderId) => request(`/orders/${orderId}/queue-position`),
  getFullQueue: (routeId) => request(`/orders/route/${routeId}/queue`),

  // Logistics
  getTracking: (routeId) => request(`/routes/${routeId}/tracking`),
  sendSOS: (data) => request('/complaints', { method: 'POST', body: { ...data, type: 'SOS' } }),
};
